import { cn } from '@/lib/format';

type Props = {
  /** Symbol id inside `/public/icons.svg` (e.g. `fact_destination`). */
  id: string;
  /** Pixel size by default; CSS units such as `1em` and `100%` are supported. */
  size?: number | string;
  className?: string;
  title?: string;
};

/**
 * Renders a single symbol from the shared `/icons.svg` sprite. The project ships
 * the sprite in `public/`, so themes get consistent iconography without bundling
 * per-icon React components. `currentColor` lets callers tint via text color.
 */
export function SpriteIcon({ id, size = 24, className, title }: Props) {
  return (
    <svg
      width={size}
      height={size}
      className={cn('inline-block max-h-full max-w-full shrink-0', className)}
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <use href={`/icons.svg#${id}`} xlinkHref={`/icons.svg#${id}`} />
    </svg>
  );
}
